var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOven(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 13.3333C23.403 13.3333 24 13.9303 24 14.6667C24 15.403 23.403 16 22.6667 16H16C15.2636 16 14.6667 15.403 14.6667 14.6667C14.6667 13.9303 15.2636 13.3333 16 13.3333H22.6667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 6.66667C28 5.19391 26.8061 4 25.3333 4H6.66667C5.1939 4 4 5.19391 4 6.66667V26.6667C4 27.403 4.59695 28 5.33333 28C6.06971 28 6.66667 27.403 6.66667 26.6667C6.66667 25.9303 7.26362 25.3333 8 25.3333H24C24.7364 25.3333 25.3333 25.9303 25.3333 26.6667C25.3333 27.403 25.9303 28 26.6667 28C27.403 28 28 27.403 28 26.6667V6.66667ZM18.6667 6.66667C20.1394 6.66667 21.3333 7.86057 21.3333 9.33333V11.2009C21.3333 11.7144 21.9151 12.0563 22.4265 12.0107C22.5056 12.0036 22.5857 12 22.6667 12C24.1394 12 25.3333 13.1939 25.3333 14.6667C25.3333 16.1394 24.1394 17.3333 22.6667 17.3333C22.5857 17.3333 22.5056 17.3297 22.4265 17.3227C21.9151 17.277 21.3333 17.619 21.3333 18.1324V20C21.3333 21.4728 20.1394 22.6667 18.6667 22.6667H9.33333C7.86057 22.6667 6.66667 21.4728 6.66667 20V9.33333C6.66667 7.86057 7.86057 6.66667 9.33333 6.66667H18.6667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOven);
export default __webpack_public_path__ + "static/media/oven.6bf9c0a9f4e4925f25e4a80a2f85d944.svg";
export { ForwardRef as ReactComponent };